/* eslint-disable react/no-multi-comp */
/* eslint-disable react/prefer-stateless-function */
import React, { Component } from "react"
import PropTypes from "prop-types"

import { hasAnyPermission } from "shared/imports/permissionFunctions"
import { canViewPacReceipts } from "shared/pac/permissionHelpers"

import {
    textGenericFilter,
    // sorting functions
    enumValueSort,
    enumLabelSort,
    createPACDonationFilter,
} from "shared/search/containers/Filter/Filters"

import {
    enumGenericFilter,
    searchifySelectGenericFilter,
    toggleGenericFilter,
} from "shared/search/containers/Filter/FilterCreators"

import {
    BulkEmailFilterableListView,
    CampaignFilterableListView,
    GrassrootsActionFilterableListView,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import {
    CampaignSelect,
    BulkEmailSelect,
    GrassrootsRegistrationPageSelect,
    IssueManagementSelect,
    CustomTargetSelect,
} from "app/static/frontend/selects/containers/PieSelect"

import { GRASSROOTS_ACTION_FILTERS_PAYMENT_TYPES } from "shared/pac/constants"

export class GrassrootsActionCampaignFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "gaCampaignFilter",
            filterKey: "for_campaigns",
            searchifyFLV: CampaignFilterableListView,
            dataTypeLabel: "Campaigns",
            selectComponent: CampaignSelect,
            displayLabel: "Participated in campaigns...",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const EmailTargetedInGrassrootsActionFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent searchifyFLV={GrassrootsActionFilterableListView} {...props} />
}
EmailTargetedInGrassrootsActionFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "supporterInGrassrootsAction",
    filterKey: "has_custom_target_email",
    dataTypeLabel: "Actions",
    selectComponent: CustomTargetSelect,
}

export class GrassrootsActionTypeFilter extends Component {
    static get defaultProps() {
        const excludedValues = [
            DjangIO.app.userdata.types.GrassrootsInteractionType.registered.value,
            DjangIO.app.userdata.types.GrassrootsInteractionType.scheduled.value,
            DjangIO.app.userdata.types.GrassrootsInteractionType.registration_form_registered.value,
        ]
        const cannotViewAuthorizedContributions = (() => {
            const hasPacPermissions =
                hasAnyPermission(DjangIO.app.models.PermissionType.pac_hybrid) ||
                hasAnyPermission(DjangIO.app.models.PermissionType.qpac_v1)

            // Users without PAC permissions can see authorized_contribution
            if (!hasPacPermissions) {
                return false
            }

            // Users with PAC permissions need receipt viewing permission to see authorized_contribution
            return !canViewPacReceipts()
        })()
        cannotViewAuthorizedContributions &&
            excludedValues.push(DjangIO.app.userdata.types.GrassrootsInteractionType.authorized_contribution.value)

        const grassrootsInteractions = DjangIO.app.userdata.types.GrassrootsInteractionType.filter_groups
            .find((group) => group.title === "Grassroots")
            .values.filter((item) => !excludedValues.includes(item))

        return {
            filterComponent: enumGenericFilter,
            uniqueFilterId: "gaTypeFilter",
            filterKey: "interaction_type__in",
            enumItems: DjangIO.app.userdata.types.GrassrootsInteractionType.region_supported_items().filter((item) =>
                grassrootsInteractions.includes(item.value),
            ),
            sortBy: enumLabelSort,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class GrassrootsActionEmailFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "gaEmailFilter",
            filterKey: "involving_email",
            searchifyFLV: BulkEmailFilterableListView,
            displayLabel: "Clicked Link in Outbox Email",
            dataTypeLabel: "Emails",
            selectComponent: BulkEmailSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class GrassrootsActionSourceFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "gaSourceFilter",
        filterKey: "source_type__in",
        enumItems: DjangIO.app.grassroots.types.UTMSourceType.region_supported_items()
            .filter((item) => item.relevant_to_campaigns)
            .filter((item) => item.label !== "Searched on Bing" && item.label !== "Searched on Yahoo"),
        sortBy: enumLabelSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class GrassrootsActionUTMSourceFilter extends Component {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "gaUTMSourceFilter",
        filterKey: "utm_combined_filter",
        placeholderText: "Search by custom link parameter...",
        displayLabel: "Custom Link Parameter",
        helpText:
            "Search for grassroots actions taken in the action center with particular UTM parameters. " +
            "This filter searches all of utm_source, utm_medium, utm_campaign, utm_term, and utm_content.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class GrassrootsActionRegistrationFormSourceFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            selectComponent: GrassrootsRegistrationPageSelect,
            uniqueFilterId: "gaRegistrationFormSourceFilter",
            filterKey: "registration_form_source_filter",
            displayLabel: "Registration Form Source",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class GrassrootsActionSocialMediaTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "gaSocialMediaTypeFilter",
        filterKey: "social_media_type__in",
        enumItems: DjangIO.app.grassroots.enums.SocialMediaType.items().filter((item) => item.supported),
        sortBy: enumLabelSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const GrassrootsActionProjectFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent IssueManagementFilterableListView {...props} />
}
GrassrootsActionProjectFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
GrassrootsActionProjectFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "stafferProjectFilter",
    filterKey: "for_project_and_subprojects",
    dataTypeLabel: "Issues",
    selectComponent: IssueManagementSelect,
}

export class GrassrootsActionApprovedFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "grassrootsActionApprovedFilter",
        filterKey: "campaign_confirmed",
        trueText: "Approved",
        falseText: "Unapproved",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class GrassrootsActionSubmittingOrganizationFilter extends Component {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "grassrootsActionSubmittingOrganizationFilter",
        filterKey: "submitting_org_name__icontains",
        placeholderText: "Search by Submitting Organization...",
        displayLabel: "Submitting Organization",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const GrassrootsActionAuthorizedContributionAmountFilter = createPACDonationFilter({
    uniqueFilterId: "grassrootsActionAuthorizedContributionAmountFilter",
    displayLabel: "Amount (in Dollars)",
    filterKeyMapping: { left: "amount_less_than", center: "amount_is_exactly", right: "amount_greater_than" },
})

export class GrassrootsActionAuthorizedContributionTransactionMethodFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "grassrootsActionAuthorizedContributionTransactionMethodFilter",
        filterKey: "transaction_method_type__in",
        enumItems: DjangIO.app.ledger.types.TransactionMethodType.items().filter((item) => item.used_in_donation_form),
        sortBy: enumValueSort,
        displayLabel: "Transaction Method",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class GrassrootsActionAuthorizedContributionPayrollFrequencyFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "grassrootsActionAuthorizedContributionPayrollFrequencyFilter",
        filterKey: "payroll_frequency_type__in",
        enumItems: DjangIO.app.ledger.types.PayrollFrequencyType.items(),
        sortBy: enumValueSort,
        displayLabel: "Payroll Frequency",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class GrassrootsActionPaymentTypeFilter extends Component {
    static defaultProps = {
        displayKey: "search_label",
        displayLabel: "Payment Type",
        enumItems: GRASSROOTS_ACTION_FILTERS_PAYMENT_TYPES,
        filterComponent: enumGenericFilter,
        filterKey: "payment_type",
        sortBy: enumValueSort,
        uniqueFilterId: "grassrootsActionPaymentTypeFilter",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class GrassrootsActionSupporterPacConditionalGivingLevelFilter extends Component {
    static defaultProps = {
        displayLabel: "Conditional Giving Level",
        filterComponent: textGenericFilter,
        filterKey: "conditional_giving_level",
        placeholderText: "Search by conditional giving level...",
        uniqueFilterId: "grassrootsActionSupporterPacConditionalGivingLevelFilter",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class GrassrootsActionHasSelectedACharityFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "grassrootsActionHasSelectedACharityFilter",
        filterKey: "has_selected_charity",
        falseText: "No",
        trueText: "Yes",
        isNullable: true,
        displayLabel: "Has Selected a Charity",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class GrassrootsActionCharityNameFilter extends Component {
    static defaultProps = {
        displayLabel: "Charity Name",
        filterComponent: textGenericFilter,
        filterKey: "selected_charity_name",
        placeholderText: "Search by charity name...",
        uniqueFilterId: "grassrootsActionCharityNameFilter",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}
